import React from 'react';
import '../styles/MessageModal.css';
import CommonButton from './CommonButton';

const MessageModal = ({ isSuccess, onClose, title, message_header, icon, message_content, button_name }) => {
  

  return (
    <div className={`message-modal-overlay ${isSuccess ? 'modal-success' : 'modal-failed'}`}>
      <div className="message-modal-content">
        <h1>{title}</h1>
        <p>
          {message_header}
        </p>
        {icon && <span className="message-modal-icon">{icon}</span>}
        <div className='message-modal-content-text'>
          {message_content}
        </div>
        <CommonButton onClick={onClose}>{button_name}</CommonButton>
      </div>
    </div>
  );
};

export default MessageModal;
